import { render, staticRenderFns } from "./RoleMethodAuth.vue?vue&type=template&id=dfe2cac4&scoped=true&"
import script from "./RoleMethodAuth.vue?vue&type=script&lang=js&"
export * from "./RoleMethodAuth.vue?vue&type=script&lang=js&"
import style0 from "./RoleMethodAuth.vue?vue&type=style&index=0&id=dfe2cac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe2cac4",
  null
  
)

export default component.exports